export default __webpack_public_path__ + "static/media/fb-menu.93ceb385.svg";